module.exports = __webpack_public_path__ + "assets/img/ic-trash-hover.7f52698f.svg";